import { createTheme, responsiveFontSizes } from "@mui/material/styles";

/**
 * The project's theme is here.
 * Can also modify all the MUI components.
 */
export const createAppTheme = (mode, isMobile) => {
    let baseTheme = createTheme({
        palette: {
            mode, // Light or dark mode.
            primary: {
                main: "#1c4199"
            },
            text: {
                disabled: mode === "light" ? "rgba(0, 0, 0, 0.55)" : "rgba(255, 255, 255, 0.75)" // Increase opacity.
            },
            background: {
                primary: mode === "light" ? "#ffffff" : "#121212",
                secondary: mode === "light" ? "#f3f3f3" : "#1e1e1e",

                red: mode === "light" ? "#fce4ec" : "#ff72a1",
                "red-a": mode === "light" ? "#fce4ec" : "#ff72a1",
                "red-b": mode === "light" ? "#fad4e0" : "#f15083",

                lightblue: mode === "light" ? "#bbdefb" : "#a0d4ff",
                "lightblue-a": mode === "light" ? "#bbdefb" : "#8ec7f5",
                "lightblue-b": mode === "light" ? "#99d1f7" : "#70afe6",

                blue: mode === "light" ? "#90caf9" : "#4eacf8",
                "blue-a": mode === "light" ? "#90caf9" : "#62b0f0",
                "blue-b": mode === "light" ? "#7ebef5" : "#3a9fe8",

                gray: mode === "light" ? "#f5f5f5" : "#b3b3b3",
                "gray-a": mode === "light" ? "#f5f5f5" : "#dadada",
                "gray-b": mode === "light" ? "#e6e6e6" : "#b4b4b4",

                orange: mode === "light" ? "#fff9c4" : "#ddd168",
                "orange-a": mode === "light" ? "#fff9c4" : "#e7de88",
                "orange-b": mode === "light" ? "#f7ed98" : "#c2b759",

                purple: mode === "light" ? "#e1bee7" : "#c77cd3",
                "purple-a": mode === "light" ? "#e1bee7" : "#cc96d4",
                "purple-b": mode === "light" ? "#d8acdf" : "#af61bb",

                green: mode === "light" ? "#c5e1a5" : "#96c465",
                "green-a": mode === "light" ? "#c5e1a5" : "#a1ca75",
                "green-b": mode === "light" ? "#b9e092" : "#82b352",

                button: {
                    red: mode === "light" ? "#d32f2f" : "#e45c5c",
                    blue: mode === "light" ? "#1976d2" : "#4995e0",
                    gray: mode === "light" ? "#666666" : "#a3a3a3",
                    orange: mode === "light" ? "#f57c00" : "#eca054",
                    purple: mode === "light" ? "#7b1fa2" : "#b85ddf",
                    green: mode === "light" ? "#689f38" : "#95cf62"
                }
            }
        },
        typography: {
            fontFamily: `"Space Grotesk", "Poppins", "Libre Bodoni", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif`,
            fontSize: isMobile ? 12 : 16
        },
        tablerow: {
            fontSize: isMobile ? 8 : 14
        },
        input: {
            fontSize: isMobile ? 8 : 14
        },
        components: {
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        minWidth: 30
                    }
                }
            },
            MuiListItemText: {
                styleOverrides: {
                    root: {
                        marginTop: 1,
                        marginBottom: 1
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        padding: "5px 2px"
                        // fontSize: 10,
                    }
                }
            }
        }
    });

    // After creating the baseTheme, we can use varibles like palette.primary.main.
    const dynamicTheme = createTheme(baseTheme, {
        components: {
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        backgroundColor: baseTheme.palette.primary.main
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: mode === "light" ? "#ffffff" : "#121212"
                    }
                }
            }
        }
    });

    return responsiveFontSizes(dynamicTheme);
};
